import React, { Component } from "react";
import ResizeObserver from "resize-observer-polyfill";
import { connect } from "react-redux";
import { Utils, SIDES } from "services/utils";
import { RESOLUTIONS } from "services/config";
import { Permissions } from "services/permissions";
import { updatePermissions } from "actions/permissions";
import { ColumnSide } from "./ColumnSide";
import { MenuItemsWrapper } from "./MenuItemsWrapper";
import PrimaryMenu from "./PrimaryMenu";

const CDN_URL = process.env.REACT_APP_CDN_URL;
const Layer2 = `${CDN_URL}navigation/nav-layer-2-new.svg`;
const MenuArrow = `${CDN_URL}navigation/nav-menu-triangle.svg`;

class SecondaryMenu extends Component {
  constructor(props) {
    super(props);
    this.myObserver = null;
    this.state = {
      navHeight: null,
      screenSize: null,
      column: null,
      columnWidth: null,
      showPrimaryMenu: false,
      menu: null,
      loggedInUsersRole: null,
    };
  }

  componentDidMount() {
    const { company_info, module } = this.props;
    let clientHeight;
    try {
      clientHeight = document.getElementById("menu-secondary").clientHeight;
    } catch (e) {
      console.log(e);
    }
    this.setNavHeight(clientHeight);
    this.checkScreenSize();
    this.myObserver = new ResizeObserver((entries) => {
      // const newClientHeight = document.getElementById('menu-secondary').clientHeight;
      const newClientHeight = document.getElementById("menu-secondary")
        ? document.getElementById("menu-secondary").clientHeight
        : null;
      entries.forEach(() => {
        this.checkScreenSize();
        this.setNavHeight(newClientHeight);
        this.setGradientPercentage();
      });
    });
    if (company_info?.customer?.id) {
      this.getUsersRole(company_info?.customer?.id);
    }
    this.getMenuNames(module);

    setTimeout(() => {
      const wrapperElement = document.querySelector(".main-content");
      if (wrapperElement) {
        this.myObserver.observe(wrapperElement);
      }
    }, 500);
  }

  componentDidUpdate(prevProps, prevState) {
    const { menu } = this.state;
    const { module, company_info, permissions } = this.props;
    if (menu !== null && menu !== prevState.menu) {
      let clientHeight;
      try {
        clientHeight = document.getElementById("menu-secondary").clientHeight;
      } catch (e) {
        console.log(e);
      }

      this.setNavHeight(clientHeight);
      this.checkScreenSize();
      this.setState({ showPrimaryMenu: false });
    }

    if (permissions !== prevProps.permissions) {
      this.getMenuNames(module);
    }
    if (prevProps.company_info !== company_info) {
      this.getUsersRole(company_info?.customer?.id);
    }
  }
  setGradientPercentage = () => {
    try {
      const { percentage } = Utils.calculateGradientPath(
        "top-graphic",
        "bottom-graphic",
        SIDES.LEFT
      );
      this.setState({ percentage });
    } catch (e) {
      console.log(e);
    }
  };
  checkScreenSize = () => {
    const screenSize = window.innerWidth;

    this.setState({ screenSize }, () => this.setColumnWidth());
  };

  setNavHeight(menuItemsHeight) {
    if (!menuItemsHeight) return;
    const screenSize = window.innerWidth;
    let height;
    if (screenSize >= RESOLUTIONS.HIGH) {
      height = 270;
    } else if (screenSize > RESOLUTIONS.MED) {
      height = 217;
    } else {
      height = 182;
    }
    const newHeight = height + menuItemsHeight;

    this.setState({ navHeight: newHeight }, () => this.setPrimaryMenuHeight());
  }
  setPrimaryMenuHeight = () => {
    const primaryMenu = document.querySelector(".primary-menu-wrapper");
    const { navHeight, screenSize } = this.state;
    let height;

    if (screenSize >= RESOLUTIONS.HIGH) {
      height = navHeight - 88;
    } else if (screenSize > RESOLUTIONS.MED) {
      height = navHeight - 90;
    } else {
      height = navHeight - 100;
    }

    if (primaryMenu) {
      primaryMenu.setAttribute("style", `margin-top: ${height}px`);
    }
  };

  setColumnWidth = () => {
    const { screenSize } = this.state;

    let columnWidth;
    if (screenSize >= RESOLUTIONS.HIGH) {
      columnWidth = 104.5;
    } else if (screenSize > RESOLUTIONS.MED) {
      columnWidth = 72;
    } else {
      columnWidth = 56;
    }

    this.setState({ columnWidth });
  };

  setPrimaryMenuMargin = (showPrimaryMenu) => {
    const primaryMenu = document.querySelector(".primary-menu-wrapper");
    this.setPrimaryMenuHeight();
    if (showPrimaryMenu) {
      if (primaryMenu) {
        primaryMenu.classList.add("hover");
      }
    } else {
      if (primaryMenu) {
        primaryMenu.classList.remove("hover");
      }
    }
  };

  onMouseOver = () => {
    const { showPrimaryMenu } = this.state;

    if (!showPrimaryMenu) {
      this.setState({ showPrimaryMenu: true }, () => {
        this.setPrimaryMenuMargin(true);
      });
    }
  };
  onMouseLeave = () => {
    const { showPrimaryMenu } = this.state;

    if (showPrimaryMenu) {
      this.setState({ showPrimaryMenu: false }, () => {
        this.setPrimaryMenuMargin(false);
      });
    }
  };
  getUsersRole = (id) => {
    const { auth_status, module } = this.props;
    const { role } = this.state;
    const { memberships = {} } = auth_status;
    const currentMembershipSelected = memberships.filter(
      (membership) => Number(membership.organizationId) === Number(id)
    );
    if (currentMembershipSelected[0].role !== role) {
      this.setState(
        { loggedInUsersRole: currentMembershipSelected[0].role },
        () => {
          this.getMenuNames(module);
        }
      );
    }
  };
  resetMenu = () => {
    const { updatePermissions } = this.props;
    this.setState({ menu: null });
    updatePermissions(null);
  };
  getMenuNames = async (module) => {
    const { loggedInUsersRole } = this.state;
    const { permissions: pages } = this.props;

    let menu = [];
    if (module === "account" && loggedInUsersRole) {
      menu = Permissions.checkMenuItemPermissionsWithRole(
        pages?.permissions,
        loggedInUsersRole
      );
    } else {
      menu = Permissions.checkMenuItemPermissions(pages?.permissions);
    }
    this.setState({ menu });
  };

  getActiveArrow = (module) => {
    return `${CDN_URL}navigation/nav-menu-triangle-active-${module}.svg`;
  };

  render() {
    const { columnWidth, navHeight, percentage, showPrimaryMenu, menu } =
      this.state;
    const { module, navigate } = this.props;
    const Assets = Utils.getNavigationAssets(module, "md");
    const TopGraphic = Assets.top;
    const BottomGraphic = Assets.bottom;

    return (
      <div className="nav-menu-secondary">
        <div className="columns-wrapper">
          <span className="top-graphic">
            <img src={TopGraphic} />{" "}
          </span>
          <span className="columns">
            <span className="left-column">
              <ColumnSide
                navHeight={navHeight}
                width={columnWidth}
                percentage={percentage}
                side="left"
              />
            </span>

            <span className="right-column">
              <ColumnSide
                navHeight={navHeight}
                width={columnWidth}
                percentage={percentage}
                side="right"
              />
            </span>
          </span>
          <span className="bottom-graphic">
            <div
              className="primary-menu-trigger"
              id="primary-menu-trigger"
              onMouseOver={this.onMouseOver}
            />
            <img id="bottomGraphic" src={BottomGraphic} />
          </span>
          {showPrimaryMenu && (
            <>
              <div className="primary-menu-wrapper">
                <PrimaryMenu
                  columnWidth={columnWidth}
                  onMouseLeave={this.onMouseLeave}
                  module={module}
                  navigate={navigate}
                />
              </div>
              <div className="primary-menu-active-shadow fade-in-fast" />
            </>
          )}
          <MenuItemsWrapper
            section={module}
            navigation="secondary"
            menu={menu}
            navigate={navigate}
            resetMenu={this.resetMenu}
          />
          <div className={showPrimaryMenu ? "menu active" : "menu"}>
            <span className="text nav-menu">MENU</span>
            <span className="arrow">
              <img
                src={showPrimaryMenu ? this.getActiveArrow(module) : MenuArrow}
              />
            </span>
          </div>
          <div className="layer-2">
            <img src={Layer2} />{" "}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    permissions: state.permissions,
  };
}

export default connect(mapStateToProps, { updatePermissions })(SecondaryMenu);
